import { AsyncScheduler } from './AsyncScheduler';
export class QueueScheduler extends AsyncScheduler {
}
//# sourceMappingURL=QueueScheduler.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs-es/scheduler/QueueScheduler.js
// module id = 145
// module chunks = 4